import firebase from "firebase";
import { EventBus } from './event-bus.js';

import * as fb from '../firebase'

function upload(prefix, galleryId, formData) {

    const photos = formData.getAll(galleryId);
    
    var storageRef = firebase.storage().ref();

    //var userId = fb.auth.currentUser.uid;
    //console.log('userId', userId)

    const promises = photos.map((x) => {
        var fileRef = storageRef.child(`${prefix}/${galleryId}/${x.name}`);
        fileRef.put(x).then((snapshot) => {
            // console.log('fileRef.put')
            // console.log('snapshot.ref', snapshot.ref.toString())
            // snapshot.ref.getDownloadURL().then(downloadURL => {
            //     //this.$emit('url', downloadURL)
            //     console.log('fileRef downloadURL', downloadURL)
            //     EventBus.$emit('file-uploaded', { name: x.name, url: downloadURL });
            // })
            EventBus.$emit('file-uploaded', { name: x.name, gs: snapshot.ref.toString() });
            
        });          
    });

    return Promise.all(promises);
}

function deleteFile(prefix, galleryId, name) {

    var storageRef = firebase.storage().ref();
    var fileRef = storageRef.child(`${prefix}/${galleryId}/${name}`);

    return fileRef.delete();
    // fileRef.delete().then(() => {
    //     // File deleted successfully
    //     EventBus.$emit('file-deleted', { name: name });
    // }).catch((error) => {
    // // Uh-oh, an error occurred!
    // });

}




export { upload, deleteFile }